// extracted by mini-css-extract-plugin
export default {"input":"FormulaFormItem_input__1sAAd","operate":"FormulaFormItem_operate__EIttd"};